<template>
  <div class="col-12 p-0">

    <div class="row top-content" v-if="loading == false">
    <div class="col-8 p-0 padding-t-10">
      {{ pathwayCount }} Pathway(s)
    </div>
    <div class="col-4 text-right p-0">
      
      <button v-if="!isReadOnly" class="btn ma-blue-btn btn-md input-height-15 pathwayBtn"
        @click="isModalVisible = true; this.verrors.clear();">New Pathway</button>
    </div>
    </div>


    <div class="row top-content" v-if="loading == true">
    <div class="col-2 p-0 padding-t-10">
      <PuSkeleton :count="1"></PuSkeleton>
    </div>
    <div class="col-6 text-right p-0">
      &nbsp;
    </div>
    <div class="col-2 text-right p-0">
      <PuSkeleton height="30px" :count="1"></PuSkeleton>
    </div>
    <div class="col-2 text-right p-0 pl-3">
      <PuSkeleton  height="30px" :count="1"></PuSkeleton>
    </div>
    </div>



    <div class="row justify-content-between pb-4" v-if="loading == true">
      <div class="col pl-0 pr-2" >
        <PuSkeleton height="120px" width="200px" :count="1"></PuSkeleton>
      </div>
      <div class="col pl-4" >
        <PuSkeleton height="120px" width="200px" :count="1"></PuSkeleton>
      </div>
      <div class="col pl-4 pr-1" >
        <PuSkeleton height="120px" width="200px" :count="1"></PuSkeleton>
      </div>
      <div class="col pl-4 pr-1" >
        <PuSkeleton height="120px" width="200px" :count="1"></PuSkeleton>
      </div>
    </div>



    <div class="row" v-if="loading == false">
      <div class="col-12 p-0">

        <p class="" v-if="pathwayLists.length == 0 && loading == false">No pathways setup on account.</p>

        <div class="col-12 p-0">
          <div class="d-flex flex-wrap">
            <div class="d-flex flex-column" v-for="(pathway, index) in pathwayLists">
            <div class="pathway_content shadow rounded">
            <div class="pathway_box" :style="'border-left: 7px solid ' 
            + pathway.ascentColor + ' !important;'">
              <p class="font-weight-bold pb-2">{{ truncate1(pathway.pathwayName) }}</p>
              <p class="flex-grow-1" style="min-height: 50px;">{{ truncate(pathway.pathwayDescription) }}</p>
              <div class="row">
                <div v-if="pathway.status == 'PUBLISH'" class="col pathway_status">
                  Published
                </div>
                <div v-else class="col pathway_status">
                  {{ pathway.status.toLowerCase() }}
                </div>
              </div>
              <div class="row">
                <div class="col-10">
                  <p><a class="font-color-00acee" @click="showPathwayStep(pathway.id, pathway.isMasterAdmin)">Show Pathway</a></p>
                </div>
                <div class="col-2 text-right pr-0" v-if="!isReadOnly">
                  <b-dropdown id="dropdown-2" text="..." class=" m-0" style="margin-top: -8px !important;">
                    <b-dropdown-text v-if="pathway.isMasterAdmin == 0"><a class="dropdown-item1 bold" @click="editPathwayStep(pathway.id)">Edit</a></b-dropdown-text>
                    <b-dropdown-text v-if="pathway.isMasterAdmin == 0"><a class="dropdown-item1 bold" @click="clonePathwayStep(pathway.id)">Duplicate</a></b-dropdown-text>
                    <b-dropdown-text><a class="dropdown-item1 bold" @click="editPathwayAction(pathway)">Rename</a></b-dropdown-text>
                    <b-dropdown-text  v-if="pathway.status == 'DRAFT'"><a class="dropdown-item1 bold" @click="activatePathwayConfirm(pathway.id)">Publish</a></b-dropdown-text>
                    <b-dropdown-text  v-if="pathway.status == 'PUBLISH'"><a class="dropdown-item1 bold" @click="deletePathwayConfirm(pathway.id)">Archive</a></b-dropdown-text>
                    <b-dropdown-text ><a class="dropdown-item1 bold" @click="openLogFullListModal(pathway.id)">View History</a></b-dropdown-text>
                    <b-dropdown-text v-if="pathway.status == 'PUBLISH'"><a class="dropdown-item1 bold" @click="openAssignAccountsListModal(pathway.id)"> Assign</a></b-dropdown-text>
                  </b-dropdown>


                </div>
              </div>
            </div>
            </div>
            </div>


          </div>
        </div>
      </div>

    </div>


    <div class="row top-content" v-if="loading == false">
    <div class="col-8 p-0 padding-t-10">
      {{ pathwayCount }} Pathway(s)
    </div>
    <div class="col-4 text-right p-0">
      &nbsp;
    </div>
    </div>


    <CreatePathwayModal :isModalVisible="isModalVisible" @close="isModalVisible = false">
      <div slot="header" class="sub-heading m-0"><h6 class="modal-title">Create new pathway</h6></div>
      <div slot="body" v-if="isModalVisible == true">
        <div class="col-12 override-padding">
          <div class="col-12 override-padding form-group">
            <label for="pathway_name">Name <span class="required">*</span></label>
            <input v-model="pathway_name"
                  name="pathway_name"
                  placeholder="Name the new pathway"
                  class="col-lg-12 input-text form-control line-height-30"
                  v-validate="'required'"
                  maxlength="140" />
            <div v-if="verrors.firstByRule('pathway_name', 'required')" class="margin-bottom-5 validate-warning-msg">Pathway Name is required</div>
          </div>
          <div class="col-12 override-padding form-group">
            <label for="pathway_description">Description</label>
            <textarea
              name="pathway_description" 
              v-model="pathway_description"
              placeholder="Describe the new pathway"
              class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25 form-control"
              maxlength="500" style="resize: none; height: 80px;">
              </textarea>
          </div>
          <div class="col-12 override-padding form-group  m-0">
            <label class="col-12 p-0 " for="pathway_description">Accent color</label>
            <div class="ascent-color-main" v-for="(color) in ascent_color">
              <div v-if="color == colors" class="ascent-color-outer" :style="'border: 1px solid '+ color">
                <div class="ascent-color1" :style="'background-color: '+ color"  @click="updateColor(color)"></div>  
              </div>
              <div v-else class="ascent-color" :style="'background-color: '+ color" @click="updateColor(color)"></div>
            </div>

            <i class="fa fa-plus-circle pickerIcon" @click="togglePicker('ADD')"></i>
          </div>

          <div class="col-12 override-padding form-group  m-0">
            <Sketch :value="colors" @input="updateFromPicker" v-show="displayPicker" class="vc-left" />
          </div>

        </div>
      </div>
      <div slot="footer" class="col-12 p-0 text-right">
        <button type="submit" class="btn btn-sm btn-blue submit_btn text-center" @click="createPathway()">Save</button>
      </div>
    </CreatePathwayModal>


    <EditPathwayModal :isModalVisible="isEditModalVisible" @close="isEditModalVisible = false">
      <div slot="header" class="sub-heading m-0"><h6 class="modal-title">Edit pathway</h6></div>
      <div slot="body" v-if="isEditModalVisible == true">
        <div class="col-12 override-padding">
          <div class="col-12 override-padding form-group">
            <label for="pathway_name">Name <span class="required">*</span></label>
            <input v-model="edit_pathway_name"
                  name="edit_pathway_name"
                  placeholder="Name the new pathway"
                  class="col-lg-12 input-text form-control line-height-30"
                  v-validate="'required'"
                  maxlength="140" />
            <div v-if="verrors.firstByRule('edit_pathway_name', 'required')" class="margin-bottom-5 validate-warning-msg">Pathway Name is required</div>
          </div>
          <div class="col-12 override-padding form-group">
            <label for="pathway_description">Description</label>
            <textarea
              name="edit_pathway_description" 
              v-model="edit_pathway_description"
              placeholder="Describe the new pathway"
              class="textarea col-xs-12 col-md-12 col-lg-12 input-height-25 form-control"
              maxlength="500" style="resize: none; height: 80px;">
              </textarea>
          </div>
          <div class="col-12 override-padding form-group m-0">
            <label class="col-12 p-0 " for="pathway_description">Accent color</label>
            <div class="ascent-color-main" v-for="(color) in edit_ascent_color">
              <div v-if="color == edit_colors" class="ascent-color-outer" :style="'border: 1px solid '+ color">
                <div class="ascent-color1" :style="'background-color: '+ color"  @click="updateEditColor(color)"></div>  
              </div>
              <div v-else class="ascent-color" :style="'background-color: '+ color" @click="updateEditColor(color)"></div>
            </div>

            <i class="fa fa-plus-circle pickerIcon" @click="togglePicker('EDIT')"></i>
          </div>

          <div class="col-12 override-padding form-group m-0">
            <Sketch :value="edit_colors" @input="updateEditFromPicker" v-show="displayPicker" class="vc-left" />
          </div>

        </div>
      </div>
      <div slot="footer" class="col-12 p-0 text-right">
        <button type="submit" class="btn btn-sm btn-blue submit_btn text-center"  @click="editPathway()">Save</button>
      </div>
    </EditPathwayModal>


      <DeleteModal :isModalVisible="isDeleteModalVisible" :id="id"  @close="isDeleteModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to archive the pathway?</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="isDeleteModalVisible = false; updatePathwayStatus(id, 'ARCHIVE')">Confirm</button>
        </div>
      </DeleteModal>


      <ActivateModal :isModalVisible="isActivateModalVisible" :id="id"  @close="isActivateModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading">Are you sure you want to publish the pathway?</div>
        <div slot="body">

        </div>
        <div slot="footer" class="col-3 override-padding">
          <button class="left col-12 btn btn-red" @click="isActivateModalVisible = false; updatePathwayStatus(activateId, 'PUBLISH')">Confirm</button>
        </div>
      </ActivateModal>


        <LogFullList 
          :isModalVisible="isLogFullListVisible"
          @closeLogFullListModal="closeLogFullListModal"
          ref="LogFullListModal">
        </LogFullList>

        <AssignAccounts 
          :isModalVisible="isAssignAccountsListVisible"
          @closeAssignAccountsListModal="closeAssignAccountsListModal"
          ref="AssignAccountsListModal">
        </AssignAccounts>




  </div>




</template>

<script>

import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import { store } from '../../store/store';
import CreatePathwayModal from '../manager/create-pathway-modal.vue';
import EditPathwayModal from '../manager/create-pathway-modal.vue';
import ColourPicker from 'vue-colour-picker';
import { Sketch } from 'vue-color'
//import 'bootstrap/js/dist/dropdown.js';
import VeeValidate from 'vee-validate';
import EventBus from '../../bus';
import { Validator } from "vee-validate";
import router from '../../router/index.js';
import ActivateModal from '../shared/delete_modal_alert.vue';
import DeleteModal from '../shared/delete_modal_alert.vue';
import LogFullList from '@/components/enterpriseadmin/pathway_audit_log_full_list.vue';
import AssignAccounts from '@/components/enterpriseadmin/assign_account_pathways.vue';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
        props: ['accountId'],
        data() {
          return {
            pathwayCount: '',
            isModalVisible: false,
            isEditModalVisible: false,
            pathway_name: '',
            pathway_description: '',
            displayPicker: false,
            colors: '#2EACEE',
            ascent_color: [
              '#2EACEE',
              '#9A54A6',
              '#EC511F',
            ],
            pathwayLists: [],
            loading: false,
            edit_pathway_name: '',
            edit_pathway_id: '',
            edit_pathway_description: '',
            edit_colors: '#2EACEE',
            edit_ascent_color: [
              '#2EACEE',
              '#9A54A6',
              '#EC511F',
            ],
            isDeleteModalVisible: false,
            isActivateModalVisible: false,
            id: '',
            activateId: '',
            isLogFullListVisible: false,
            isAssignAccountsListVisible: false,
          }
        },
        components: {
          CreatePathwayModal,
          ColourPicker,
          Sketch,
          EditPathwayModal,
          ActivateModal,
          DeleteModal,
          LogFullList,
          AssignAccounts,
        },
        computed: {
          isReadOnly(){
            if (this.$store.state.enterprise_type === 'Readonly') {
              return true;
            } else {
              if (this.$store.state.switch_admin_enterprise_isreadonly) {
                return true;
              } else {
                return false;
              }
            }
          }
        },
        methods: {
          openAssignAccountsListModal(pathwayId) {
            this.$refs.AssignAccountsListModal.getAccounts(pathwayId);
            this.isAssignAccountsListVisible = true;
          },
          closeAssignAccountsListModal() {
            this.isAssignAccountsListVisible = false;
          },
          openLogFullListModal(pathwayId) {
            this.$refs.LogFullListModal.getActivityData(pathwayId);
            this.isLogFullListVisible = true;
          },
          closeLogFullListModal() {
            this.isLogFullListVisible = false;
          },
          truncate1: function (text) {
            if (text.length > 25) {
                return text.substring(0, 25) + '...';
            } else {
                return text;
            }
          },
          activatePathwayConfirm(id) {

            axios('/check-pathway-has-steps/' + id,
            {
                method: 'GET',
            })
            .then(resp => {
              if(resp.data.flag == 1) {
                alert(resp.data.msg);
                return false;
              }
              else {
                this.isActivateModalVisible = true;
                this.activateId = id;
              }
            })
            .catch(() => {
            });

          },
          deletePathwayConfirm: function(id) {
            this.isDeleteModalVisible = true;
            this.id = id;
          },

          updatePathwayStatus(id, status_text) {
            axios('/edit-pathway/' + id,
             {
               method: 'PATCH',
               data: { "status": status_text},
             }
            )
            .then((resp) => {
              this.getPathwayLists();
              this.id = '';
              this.activateId = '';
            })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
            });
          },
          resourceRedirect() {
            router.push('/resourses');
          },
          truncate: function (text) {
            if (text.length > 150) {
                return text.substring(0, 150) + '...';
            } else {
                return text;
            }
          },
          editPathwayAction(pathway) {
            this.edit_pathway_id = pathway.id;
            this.edit_pathway_name = pathway.pathwayName;
            this.edit_pathway_description = pathway.pathwayDescription;
            this.edit_colors = pathway.ascentColor;
            if(this.edit_ascent_color.indexOf(this.edit_colors) === -1) {
              this.edit_ascent_color.push(this.edit_colors);
            }
            this.isEditModalVisible = true;
          },
          editPathway: function() {
            this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              axios('/edit-pathway/' + this.edit_pathway_id,
                 {
                   method: 'PATCH',
                   data:
                    {
                      pathway_name: this.edit_pathway_name,
                      pathway_description: this.edit_pathway_description,
                      ascent_color: this.edit_colors,
                    },
                 }
               )
              .then((resp) => {
                  this.getPathwayLists();
                  this.isEditModalVisible = false;
                  this.edit_pathway_name = '';
                  this.edit_pathway_description = '',
                  this.displayPicker = '',
                  this.edit_pathway_id = '';
                  this.edit_colors = '#2EACEE';
                  this.edit_ascent_color = [];
                  this.edit_ascent_color = [
                    '#2EACEE',
                    '#9A54A6',
                    '#EC511F',
                  ];
                  this.verrors.clear();
               })
              .catch(error => {
                if(error.response.data.message == 'Access denied.') {
                  router.push("/forbidden");
                }
              });
            }
            });
          },
          clonePathwayStep: function(pathwayId) {
            this.loading = true;
            axios('/clone-pathway/' + pathwayId,
              {
                method: 'POST',
              }
            )
            .then((resp) => {
               this.getPathwayLists();
            })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
            });
            
          },
          showPathwayStep: function(pathwayId, isMasterAdmin) {
            this.$store.dispatch('pathway_steps', '');
            router.push("/enterpriseadmin-pathway-step-show-pathway/" + pathwayId + "/" + isMasterAdmin);
          },
          editPathwayStep: function(pathwayId) {
            this.$store.dispatch('pathway_steps', '');
            router.push("/enterpriseadmin-pathway-step-builder/" + pathwayId);
          },
          createPathway: function() {
            this.$validator.validateAll().then((result) => {
            if ((this.verrors.items.length === 0)) {
              axios('/create-pathway',
                 {
                   method: 'POST',
                   data:
                    {
                      pathway_name: this.pathway_name,
                      pathway_description: this.pathway_description,
                      ascent_color: this.colors,
                      accountId: this.accountId,
                    },
                 }
               )
              .then((resp) => {
                  this.getPathwayLists();
                  this.isModalVisible = false;
                  this.pathway_name = '';
                  this.pathway_description = '',
                  this.displayPicker = '',
                  this.colors = '#2EACEE';
                  this.ascent_color = [];
                  this.ascent_color = [
                    '#2EACEE',
                    '#9A54A6',
                    '#EC511F',
                  ];
                  this.verrors.clear();
                  this.editPathwayStep(resp.data);
               })
              .catch(error => {
                if(error.response.data.message == 'Access denied.') {
                  router.push("/forbidden");
                }
              });
            }
            });
          },
          getPathwayLists() {
            this.pathwayLists = [];
            this.loading = true;
            axios('/get-pathway',
               {
                 method: 'GET',
                 params: {
                   account_id: this.accountId,
                 }
               }
             )
            .then((resp) => {
                this.loading = false;
                this.pathwayCount = resp.data.length;
                this.pathwayLists = resp.data;
             })
            .catch(error => {
              if(error.response.data.message == 'Access denied.') {
                router.push("/forbidden");
              }
            });
          },
          showPicker() {
            document.addEventListener('click', this.documentClick);
            this.displayPicker = true;
          },

          hidePicker() {
            document.removeEventListener('click', this.documentClick);
            this.displayPicker = false;
          },
          togglePicker(type) {
            if(type == 'ADD') {
              var colorslen = this.ascent_color.length;
            }
            else {
              var colorslen = this.edit_ascent_color.length;
            }
            if(colorslen >= 10) {
              alert("You can add only 10 colors.");
              return false;
            }
            else {
              this.displayPicker ? this.hidePicker() : this.showPicker();
            }
          },
          updateFromPicker(color) {
            this.colors = color.hex;
            if(this.ascent_color.indexOf(this.colors) === -1) {
              this.ascent_color.push(this.colors);
            }
            this.displayPicker = false;
          },
          updateColor(color) {
            this.colors = color;
          },
          updateEditFromPicker(color) {
            this.edit_colors = color.hex;
            if(this.edit_ascent_color.indexOf(this.edit_colors) === -1) {
              this.edit_ascent_color.push(this.edit_colors);
            }
            this.displayPicker = false;
          },
          updateEditColor(color) {
            this.edit_colors = color;
          },

        },
        created() {
          this.getPathwayLists();
        },
}
</script>
<style scoped>
a, a:hover, a:focus {
  cursor: pointer; 
}
.pathway_box {
  border-color: lightgray !important;
  border-left: 7px solid #00ACEE !important;
  border-radius: 7px !important;
  background-color: white !important;
  padding: 8px 10px 5px 10px;
}

.pathway_box p {
  margin-bottom: 3px;
}

.d-flex div.pathway_box {
  margin-right: 15px;
  width: 210px;
  background-color: burlywood;
}

.pathway_box .dropdown button {
  margin-top: -10px;
}

.pathway_box .dropdown button:focus {
  box-shadow: unset;
}

.accent_color_add {
  height: 23px;
  width: 23px;
  display: inline-flex;
  background-color: #e9e9e9;
  color: #646e71;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}

.pathway_save_btn {
  padding: 5px 10px !important;
  text-transform: uppercase;
  font-size: 18px;
  font-weight: 400;
  width: 60%; height: 40px;
}
</style>
<style >
.vc-sketch {
    position: absolute !important;
    top: -260px !important;
    left: 50px !important;
}
.ascent-color {
  height: 15px;
  width: 15px;
  border-radius: 10px;
  cursor: pointer;
  float: left;
  margin-top: 3px;
}
.ascent-color1 {
  height: 12px;
  width: 12px;
  border-radius: 10px;
  cursor: pointer;
  float: left;
  margin-top: 3px;
}
.ascent-color-main {
  float: left;
  margin-right: 10px;
}
.ascent-color-outer {
  float: left;
  padding: 0px 2px 2px 2px;
  border-radius: 15px;
  margin-top: 1px;
}
.dropdown-item {
  cursor: pointer;
  color: #BBB !important;
}
#dropdown-2 .dropdown-toggle::after{
  display: none;
}
#dropdown-2 .dropdown-toggle {
  background: none;
  border: 0;
  color: #002F42;
  font-weight: bold;
}
#dropdown-2 .dropdown-menu {
  margin: 0px;
  padding: 0px;
  padding-top: 3px;
  padding-bottom: 3px;
  width: 110px;
}
#dropdown-2 .b-dropdown-text {
  margin-bottom: 0px;
}
#dropdown-2 .b-dropdown-text {
  cursor: pointer;
  color: #848884 !important;
  padding: 2px 5px 2px 10px;
  font-size: 14px;
}
#dropdown-2.dropdown a, #dropdown-2.dropdown a:hover {
  font-size: 15px;
  color: #848884 !important;
  font-weight: bold;
}
#dropdown-2 .dropdown-item:hover, #dropdown-2 .dropdown-item:active, #dropdown-2 .dropdown-item:focus, #dropdown-2.dropdown a:hover, #dropdown-2.dropdown a:focus, #dropdown-2.dropdown a:active {
  background: none !important;
  text-decoration: none !important;
}
.pathwayBtn, .pathwayBtn:hover, .pathwayBtn:focus {
  padding: 7px 25px; border-radius: 15px !important;
  width: 140px;
}
.top-content {
  min-height: 80px;padding-top: 15px !important; padding-bottom: 10px !important;
}
.pathway_content {
  margin-bottom: 25px; margin-right: 25px;
}
.pathway_status {
  font-size: 12px;
  font-style: italic;
  text-align: right;
  padding-right: 0px;
  text-transform: capitalize;
}
.pickerIcon {
  cursor: pointer; font-size: 17px; margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterpriseadmin_pathway_list_tab.vue